import {createEnumType} from 'acscp/api/models/customTypes/enumUtils';

export enum DateType {
    EXACT = 'EXACT',
    RANGE = 'RANGE',
    MONTH = 'MONTH',
}

export const DateTypeDynamic =  createEnumType('DateType', DateType);
